import React from 'react'
import { FormattedMessage } from 'react-intl'
import { API_ENDPOINTS } from '../config/api'

export const PENDING_CLAIM_KEY = 'pendingClaimResponseId'

interface Props {
  /**
   * When the user is signing in from the "save my results" step, the anonymous
   * response id is stashed before the OAuth redirect so the callback page can
   * attach it to the new account once they come back signed in.
   */
  claimResponseId?: string | null
}

/**
 * Google + Apple sign-in buttons. They leave the page for the provider, so any
 * pending response-to-claim is stored first and picked up by the callback page.
 */
const SocialSignInButtons: React.FC<Props> = ({ claimResponseId }) => {
  const go = (endpoint: string) => {
    if (claimResponseId) {
      localStorage.setItem(PENDING_CLAIM_KEY, claimResponseId)
    }
    const returnTo = encodeURIComponent(window.location.origin)
    window.location.href = `${endpoint}?return_to=${returnTo}`
  }

  return (
    <div className="space-y-2">
      <button
        type="button"
        onClick={() => go(API_ENDPOINTS.auth.google)}
        className="w-full flex items-center justify-center gap-3 border border-border rounded-lg py-2.5 font-medium hover:bg-background transition-colors"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/>
          <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
          <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
          <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
        </svg>
        <FormattedMessage id="auth.google" />
      </button>
      <button
        type="button"
        onClick={() => go(API_ENDPOINTS.auth.apple)}
        className="w-full flex items-center justify-center gap-3 border border-border rounded-lg py-2.5 font-medium hover:bg-background transition-colors"
      >
        <svg width="16" height="18" viewBox="0 0 16 18" aria-hidden="true" fill="currentColor">
          <path d="M13.36 13.74c-.24.56-.53 1.07-.87 1.55-.46.65-.84 1.1-1.13 1.35-.45.41-.93.62-1.45.64-.37 0-.82-.11-1.34-.32-.52-.21-1-.32-1.44-.32-.46 0-.95.11-1.49.32-.54.21-.97.32-1.3.33-.5.02-.99-.2-1.47-.65-.31-.27-.71-.74-1.19-1.41-.51-.71-.94-1.54-1.27-2.49C.36 11.93.18 10.93.18 9.96c0-1.11.24-2.07.72-2.87.38-.64.88-1.15 1.51-1.52.63-.37 1.31-.56 2.04-.57.39 0 .91.12 1.55.36.64.24 1.05.36 1.23.36.13 0 .59-.14 1.36-.42.73-.26 1.35-.37 1.85-.33 1.37.11 2.4.65 3.08 1.62-1.22.74-1.83 1.78-1.82 3.11.01 1.04.39 1.9 1.13 2.59.34.32.71.57 1.13.74-.09.26-.19.51-.3.75zM10.7.36c0 .83-.3 1.6-.91 2.31-.73.85-1.61 1.34-2.57 1.26a2.58 2.58 0 0 1-.02-.31c0-.79.35-1.64.97-2.33.31-.35.7-.64 1.18-.87.48-.23.93-.36 1.35-.38.01.11.02.22.02.32z"/>
        </svg>
        <FormattedMessage id="auth.apple" />
      </button>
    </div>
  )
}

export default SocialSignInButtons
